import { ClassBase } from './ClassBase.js'
import './windowInfo.js';
import {nextTick} from '../utils/nextTick.js';
import {v4 as uuid} from '../utils/uuid.js';

/**
@class Tree
@classdesc ツリーメニュー
@param {JQuery | HTMLElement | String} el 対象のルート要素を指定
@param {Tree#Options} [op] ツリーのオプションオブジェクト

@example <caption>HTML</caption>
<div class="treeMenu">
	<ul class="treeMenu_list" data-tree-list>
		<li class="treeMenu_item" data-tree-item>
			<div class="treeMenu_itemHead" data-tree-head>
				<a href="" class="treeMenu_name">111111111111111111</a>
				<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
			</div>
			<ul class="treeMenu_list" data-tree-list>
				<li class="treeMenu_item" data-tree-item>
					<div class="treeMenu_itemHead" data-tree-head>
						<a href="" class="treeMenu_name">222222222222222222</a>
						<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
					</div>
					<ul class="treeMenu_list" data-tree-list>
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name" data-tree-current>33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
					</ul><!-- /.tree_list -->
				</li><!-- /.tree_item -->
				<li class="treeMenu_item" data-tree-item>
					<div class="treeMenu_itemHead" data-tree-head>
						<a href="" class="treeMenu_name">222222222222222222</a>
						<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
					</div>
					<ul class="treeMenu_list" data-tree-list>
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
					</ul><!-- /.tree_list -->
				</li><!-- /.tree_item -->
			</ul><!-- /.tree_list -->
		</li><!-- /.tree_item -->
		<li class="treeMenu_item" data-tree-item>
			<div class="treeMenu_itemHead" data-tree-head>
				<a href="" class="treeMenu_name">111111111111111111</a>
				<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
			</div>
			<ul class="treeMenu_list" data-tree-list>
				<li class="treeMenu_item" data-tree-item>
					<div class="treeMenu_itemHead" data-tree-head>
						<a href="" class="treeMenu_name">222222222222222222</a>
						<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
					</div>
					<ul class="treeMenu_list" data-tree-list>
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
					</ul><!-- /.tree_list -->
				</li><!-- /.tree_item -->
				<li class="treeMenu_item" data-tree-item>
					<div class="treeMenu_itemHead" data-tree-head>
						<a href="" class="treeMenu_name">222222222222222222</a>
						<a href="javascript: void(0);" class="treeMenu_toggle" data-tree-toggle></a>
					</div>
					<ul class="treeMenu_list" data-tree-list>
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
						<li class="treeMenu_item" data-tree-item>
							<div class="treeMenu_itemHead" data-tree-head>
								<a href="" class="treeMenu_name">33333333333333333333</a>
							</div>
						</li><!-- /.tree_item -->
					</ul><!-- /.tree_list -->
				</li><!-- /.tree_item -->
			</ul><!-- /.tree_list -->
		</li><!-- /.tree_item -->
	</ul><!-- /.tree_list -->
</div><!-- /.tree -->

@example <caption>JS</caption>
import {Tree} from '/assets/js/modules/Tree.js'
new Tree('.treeMenu', {
	autoOpen: true,
	beforeInit: (instance) => { console.log('beforeInit', instance) },
	afterInit: (instance) => { console.log('afterInit', instance) },
	beforeOpen: (instance) => { console.log('beforeOpen', instance) },
	afterOpen: (instance) => { console.log('afterOpen', instance) },
	beforeClose: (instance) => { console.log('beforeClose', instance) },
	afterClose: (instance) => { console.log('afterClose', instance) },
})
*/

/**
@typedef {Object} Tree#Options ツリーのオプションオブジェクト
@prop {Boolean} [autoOpen=true] 初期化時にdata-tree-currentまで自動的に開くかどうか
@prop {Boolean} [defaultOpen=false] 初期化時に全部開いておくかどうか
@prop {Tree#beforeInit} [beforeInit] 初期化開始時に実行される関数
@prop {Tree#afterInit} [afterInit] 初期化完了時に実行される関数
@prop {Tree#beforeOpen} [beforeOpen] オープン前に実行される関数
@prop {Tree#afterOpen} [afterOpen] オープン後に実行される関数
@prop {Tree#beforeClose} [beforeClose] クローズ前に実行される関数
@prop {Tree#afterClose} [afterClose] クローズ後に実行される関数
*/

/**
初期化開始時に実行される関数
@callback Tree#beforeInit
@param {Tree} instance {@Link Tree}のインスタンス
*/

/**
初期化完了時に実行される関数
@callback Tree#afterInit
@param {Tree} instance {@Link Tree}のインスタンス
*/

/**
オープン前に実行される関数
@callback Tree#beforeOpen
@param {Tree} instance {@Link Tree}のインスタンス
*/

/**
オープン後に実行される関数
@callback Tree#afterOpen
@param {Tree} instance {@Link Tree}のインスタンス
*/

/**
クローズ前に実行される関数
@callback Tree#beforeClose
@param {Tree} instance {@Link Tree}のインスタンス
*/

/**
クローズ後に実行される関数
@callback Tree#afterClose
@param {Tree} instance {@Link Tree}のインスタンス
*/
export class Tree extends ClassBase {
	constructor(el, op){
		super(el)
		this.op = {
			autoOpen: true,
			defaultOpen: false,

			beforeInit: null,
			afterInit: null,
			beforeOpen: null,
			afterOpen: null,
			beforeClose: null,
			afterClose: null,
			...op,
		}

		/**
			ルート要素
			@type {JQuery}
			@name Tree#$el
		*/

		/**
			ツリーの各アイテムのマップ
			@type {Map}
		*/
		this.list = new Map()

		this.$el.find('[data-tree-item]').each((index, el) => {
			const id = uuid();
			this.list.set(id, new TreeItem(el, id, this.op))
		});

		const _this = this;
		this.$el.find('[data-tree-toggle]').on('click', function(event) {
			event.preventDefault();
			_this.#toggle(this, _this.op)
		});

		this.op.beforeInit && this.op.beforeInit(this)

		const prArr = this.op.autoOpen && this.$el.find('[data-tree-current]')[0] ? this.#openToCurrent(this.$el.find('[data-tree-current]').closest('[data-tree-item]'), []): []
		Promise.all(prArr).then(() => {
			this.op.afterInit && this.op.afterInit(this)
		})

	}

	async #open(el, op){
		const localOp = {
			...this.op,
			...op
		}
		const target = this.list.get($(el).closest('[data-tree-item]').attr('data-tree-id'));

		localOp.beforeOpen && localOp.beforeOpen(this)
		await target.open(localOp)
		localOp.afterOpen && localOp.afterOpen(this)
		return this;
	}

	async #close(el, op){
		const localOp = {
			...this.op,
			...op
		}
		const target = this.list.get($(el).closest('[data-tree-item]').attr('data-tree-id'));

		localOp.beforeClose && localOp.beforeClose(this)
		await target.close(localOp)
		localOp.afterClose && localOp.afterClose(this)
		return this;
	}

	async #toggle(el, op){
		const localOp = {
			...this.op,
			...op
		}
		const flag = this.list.get($(el).closest('[data-tree-item]').attr('data-tree-id')).isOpen;
		return flag ? this.#close(el, localOp) : this.#open(el, localOp)
	}

	#openToCurrent(el, promiseArr){
		const origin = $(el)
		if(!origin[0]) { return }

		promiseArr.push(new Promise(async (resolve) => {
			this.#openToCurrent(origin.parent().closest('[data-tree-item]'), promiseArr)
			await this.#open(origin, {
				beforeOpen: null,
				afterOpen: null,
			})
			resolve(this)
		}))
		return promiseArr;
	}
}

/*-------------------------------------------------------------------
* TreeItem
-------------------------------------------------------------------*/
class TreeItem{
	constructor(el, id, op){
		this.op = op;
		this.id = id;
		this.$el = $(el);
		this.$btn = this.$el.children('[data-tree-head]').children('[data-tree-toggle]');
		this.$child = this.$el.children('[data-tree-list]');
		this.$el.attr('data-tree-id', this.id)
		this.$btn.attr('data-tree-id', this.id)
		this.$child.attr('data-tree-id', this.id)
		this.isOpen = false;


		this.op.defaultOpen && this.open(this.op);
	}

	async open(op){
		return new Promise(resolve => {
			if(!this.$child[0]) { resolve(this); return }

			this.isOpen = true;
			this.$el.attr('data-tree-item', 'open')
			this.$btn.attr('data-tree-toggle', 'open')
			this.$child.attr('data-tree-list', 'open')

			this.$child
				.off('transitionend')
				.on('transitionend', (e) => {
					e.preventDefault();
					if(e.originalEvent.target != this.$child[0]) return;
					this.$child.css({
						height: 'auto'
					})
					this.$child.off('transitionend')
					windowInfo.updateSize();
					resolve(this)
				})
				.css({
					height: this.$child.outerHeight()
				});
			nextTick(()=> {
				const h = this.$child[0].scrollHeight + parseInt(this.$child.css('padding-top')) + parseInt(this.$child.css('padding-bottom'));
				this.$child.css({
					height: h
				})
			})
		})

	}

	async close(op){
		return new Promise(resolve => {
			if(!this.$child[0]) { resolve(this); return }

			this.isOpen = false;
			this.$el.attr('data-tree-item', '')
			this.$btn.attr('data-tree-toggle', '')
			this.$child.attr('data-tree-list', '')

			const h = 0;
			this.$child
				.off('transitionend')
				.on('transitionend', (e) => {
					e.preventDefault();
					if(e.originalEvent.target != this.$child[0]) return;
					this.$child.removeAttr('style')
					this.$child.off('transitionend')
					windowInfo.updateSize();
					resolve(this)
				})
				.css({
					height: this.$child.outerHeight()
				});
			nextTick(()=> {
				this.$child.css({
					height: h
				})
			})
		})
	}
}

/**
$('[data-tree]')をターゲットに[data-tree]の値をオプションに{@link Tree}をインスタンス化する


@example <caption>HTML構造</caption>
<div class="treeMenu" data-tree='{
	"autoOpen": false
}'>
	<!-- 省略：html構造の詳細は{@Link Tree}のExamplesを参照 -->
</div>

@example <caption>JS</caption>
import {tree} from '/assets/js/modules/Tree.js'
tree()
*/
export const tree = () => {
	$('[data-tree]').each((i, e) => {
		new Tree(e, $(e).data('tree'))
	})
}